import React, { Component } from "react"
import { CostCodeGroupExtendedContainer } from "components/costCodeGroups/redux/CostCodeGroupContainers"

export class CostCodeGroupExtendedPage extends Component {
    render() { return (<CostCodeGroupExtendedContainer costCodeGroupId={this.props.match.params.costCodeGroupId} />) }
}